import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {DropdownModule} from 'primeng/primeng';
import {CustomPaginationComponent} from './pagination/custom-pagination.component';
import {FilterHeaderComponent} from './filter-header/filter-header.component';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {LoadingSpinnerComponent} from './loading-spinner/loading-spinner.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DropdownModule,
    NgbPaginationModule,
    BrowserModule,
    FormsModule,
    TranslateModule
  ],
  declarations: [
    CustomPaginationComponent,
    FilterHeaderComponent,
    LoadingSpinnerComponent
  ],
  exports: [
    CustomPaginationComponent,
    FilterHeaderComponent,
    LoadingSpinnerComponent
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/core/core.module.ts